import { client } from "../../api/client"
import { getApiPayload } from "../../utils/getApiPayload"
import localTicketStore from "../../features/tickets/data/localTicketStore"

export const fetchTicketById = async (id) => {

    // If using local data, return the ticket from the local store. This prevents 
    // crashes if a SignalR notification is received in local mode
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        // Return the specified id from the local store
        const all = await localTicketStore.getAllTickets()
        const matches = all && all.Items ? all.Items.filter(t => t && Number(t.id) === Number(id)) : []
        return matches.length > 0 ? { Items: [matches[0]] } : { Items: [] }
    }

    const responseAreas = await client.get("permissions/areas")
    if (responseAreas.data) {
        var siteList = `{"siteList":"${responseAreas.data.map(({ id }) => id).join(',')}"}`
        const apiPayload = getApiPayload('siteList', 'companyID', siteList)
        const parsed = JSON.parse(apiPayload)
        const updatedPayload = JSON.stringify({
            filter: [
                { op: 'and', items: [
                    { op: 'eq', field: 'id', value: String(id) },
                    ...(parsed.filter || [])
                ]}
            ]
        })
                
        var uri = "autotaskapi/tickets/query"
        var responseAutotask = await client.post(uri, updatedPayload)
        return responseAutotask.data
    } else {
        return []
    }
}